import React from 'react';
import { Typography, Link } from '@mui/material';

/**
 * The floating reCAPTCHA badge is hidden site-wide (see index.css) because it
 * covered page content on phones. Google allows that only if this notice is
 * shown wherever reCAPTCHA is used, so render it next to every protected form.
 */
const RecaptchaNotice: React.FC<{ mt?: number }> = ({ mt = 2 }) => (
    <Typography
        variant="caption"
        color="text.secondary"
        dir="rtl"
        sx={{ display: 'block', mt, textAlign: 'center', lineHeight: 1.8 }}
    >
        این سایت توسط reCAPTCHA محافظت می‌شود و{' '}
        <Link href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">سیاست حفظ حریم خصوصی</Link>
        {' '}و{' '}
        <Link href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer">شرایط استفاده</Link>
        {' '}گوگل در آن اعمال می‌شود.
    </Typography>
);

export default RecaptchaNotice;
